export const packageHighlights: string[] = [
  'One contact instead of 10+ vendors, one invoice with all-inclusive packages',
  'Photography, florals and cake included, fully customizable, or bring approved vendors of your choice',
  'Farm-to-table catering and a full bar',
  'Your own coordinator from tour to send-off',
  'The whole estate, never shared with another wedding',
]
